import Point from './Point'

const HALF_PI = Math.PI * 0.5
const timeStep = (1 / 80)

const Ease = {
  inCubic(t, b, c, d) {
    t /= d
    return c * t * t * t + b
  },
  outCubic(t, b, c, d) {
    t /= d
    t--
    return ((c * (t * t * t + 1)) + b)
  },
  inOutCubic(t, b, c, d) {
    t /= d / 2
    if (t < 1) return (c / 2) * t * t * t + b
    t -= 2
    return (c / 2) * (t * t * t + 2) + b
  },
  inBack(t, b, c, d, s) {
    s = s || 1.70158
    // eslint-disable-next-line no-return-assign
    return c * (t /= d) * t * ((s + 1) * t - s) + b
  },
}

function cubeBezier(p0, c0, c1, p1, t) {
  // eslint-disable-next-line prefer-const
  let p = new Point()
  // eslint-disable-next-line prefer-const
  let nt = (1 - t)

  p.x = nt * nt * nt * p0.x + 3 * nt * nt * t * c0.x + 3 * nt * t * t * c1.x + t * t * t * p1.x
  p.y = nt * nt * nt * p0.y + 3 * nt * nt * t * c0.y + 3 * nt * t * t * c1.y + t * t * t * p1.y

  return p
}

class Particle {
  constructor(p0, p1, p2, p3) {
    this.p0 = p0
    this.p1 = p1
    this.p2 = p2
    this.p3 = p3
    this.time = 0
    this.duration = 3 + Math.random() * 2
    this.color = `#${Math.floor((Math.random() * 0xffffff)).toString(16)}`
    this.w = 12
    this.h = 9
    this.complete = false
  }

  update() {
    this.time = Math.min(this.duration, this.time + timeStep)
    const f = Ease.outCubic(this.time, 0, 1, this.duration)
    const p = cubeBezier(this.p0, this.p1, this.p2, this.p3, f)

    const dx = p.x - this.x
    const dy = p.y - this.y

    this.r = Math.atan2(dy, dx) + HALF_PI
    this.sy = Math.sin(Math.PI * f * 10)
    this.x = p.x
    this.y = p.y

    this.complete = this.time === this.duration
  }

  draw(context) {
    context.save()
    context.translate(this.x, this.y)
    context.rotate(this.r)
    context.scale(1, this.sy)

    context.fillStyle = this.color
    context.fillRect(-this.w * 0.5, -this.h * 0.5, this.w, this.h)
    context.restore()
  }
}

export default Particle
